import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import SignInForm from '../../components/forms/SignInForm';
import { signInCommunity, authenticate } from '../../store/action/auth';
import ReactInterval from 'react-interval';
import {identify, trackEvent} from "../../services/analytics";
import {Helmet} from "react-helmet";

const SignInCommunity = (props) => {
    const queryParams = new URLSearchParams(window.location.search);
    const [ values, setValues ] = useState({
        email:'',
        password:'',
        error:'',
        loading: false,
        redirectToReferrer: false,
        sso: queryParams.get('sso'),
        sig: queryParams.get('sig'),
    });
    
    const { email, password, error, redirectToReferrer, sso, sig } = values;

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const onSubmit = (event) => {
        setValues({...values, error:false, loading:true});
        signInCommunity({email, password, sso, sig})
            .then(data => {
                if (data.error) {
                    setValues({...values, error:data.error, loading:false})
                } else {
                    // alert(data.redirect_link)
                    window.location.assign(data.redirect_link);
                    // trackEvent("User Sign In Community",{
                    //     action: "track",
                    //     category: "Users",
                    //     label: 'Sign In Community From Website',
                    //     event: "Click"
                    // });

                    // authenticate( user, () => {
                    //         identify(user.user._id, user);
                    //         setValues({
                    //             ...values,
                    //             redirectToReferrer: true,
                    //             loading:false
                    //         });
                    //     }
                    // )
                }
            })
    };

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{display: error ? '' : 'none'}}
        >
            { error }
        </div>
    );

    const redirectUser = () => {
        if (redirectToReferrer) {
            return <Redirect to="/overview" />
        }
    };

    const onLoading = e => {
        setValues({ ...values, loading:true})
    };

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Biteship: Sign In</title>
                <meta name="description" content="Sign in to your account and start shipping!" />
                <link rel="canonical" href="https://biteship.com/signin/community" />
            </Helmet>
            <ReactInterval
                timeout={2000}
                enabled={values.loading}
                callback={() => onSubmit()}
            />
           
            <div className="peers ai-s fxw-nw h-100vh">
                <div
                    className="d-n@sm- peer peer-greed bgpX-c bgpY-c bgsz-cv pos-r"
                    style={{
                        backgroundImage: 'url("images/bg.jpg")',
                        height: '100%!important',
                        position: 'relative!important',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                </div>
                <div
                    className="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r"
                    style={{ minWidth: '320px' }}
                >
                    <h2 id="brand-logo">
                        <a className="navbar-brand" id="header-logo">
                            <img
                                className="rounded-full" 
                                style={{height:72}}
                                src={"/images/logos/biteship.png"} 
                                alt=""
                            />
                        </a>
                    </h2>
                    { showError() }
                    { redirectUser() }
                    <SignInForm
                        handleChange={handleChange}
                        values={values}
                        loading={values.loading}
                        onSubmit={onLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default SignInCommunity;
